import React from "react";
import "./HeldReservations.sass";
import ResortResult from "Interfaces/ResortResultInterface";
import HeldResort from "./HeldResort";
import MvModal, { MvResortModal } from "Generic/MvModal"
// @ts-ignore
import {LocalizationContext} from 'react-localize';

type HeldReservationsState = {
  openModal: boolean,
  propCode: string,
};

type Props = {
  resorts: ResortResult[];
  deleteHeldResorts(ReservedInventoryID: number | null): Promise<any>;
  confirmHeldResort(reservation: ResortResult): Promise<boolean>;
};

class HeldReservations extends React.Component<Props,HeldReservationsState> {
  constructor(props: Props) {
    super(props);
    this.changePropCode = this.changePropCode.bind(this);
    this.state = {
      openModal : false,
      propCode: "",
    };
  }

  toggleModal = (propCode: string) => {
    this.setState({
        openModal: !this.state.openModal,
        propCode,
    })
  }

  changePropCode(propCode: string) {
    this.setState({
        propCode: propCode
    })
  }

  render() {
    const {localize} = this.context;
    const { resorts } = this.props;

    return (
      <div className="held-reservations">
        <MvResortModal
          show={this.state.openModal}
          propertyCode={this.state.propCode}
          toggle={() => this.setState({ ...this.state, openModal: !this.state.openModal })}
        />
        <div className="held-reservations-info">
          <div className="held-reservations-header">
            {localize('static.content.temporarily-held-reservations-header')}
          </div>
          <div className="held-reservations-line1">
            <p><span className="important-text">{localize('static.content.important')}</span> <span className="t-and-c-para" dangerouslySetInnerHTML={{__html: localize('static.content.temporarily-held-reservations-line1')}}></span>
            </p>
          </div>
          <div className="held-reservations-line2">
            <p>{localize('static.content.temporarily-held-reservations-line2')}</p>
          </div>
        </div>
        <div className="held-resorts">
          {resorts.map((resort, i) => (
            <HeldResort
              key={resort.ReservedInventoryID}
              resort={resort}
              deleteHeldResorts={this.props.deleteHeldResorts}
              confirmHeldResort={this.props.confirmHeldResort}
              openModal={this.toggleModal}
              propCode={this.changePropCode}
            />
          ))}
        </div>
      </div>
    );
  }
}

HeldReservations.contextType = LocalizationContext;
export default HeldReservations;
